<template>
  <v-form ref="uploadForm" v-model="valid" lazy-validation>
    <slot></slot>

    <div v-for="(file, index) in files" :key="index">
      <v-text-field
        :value="file.fileName"
        prepend-icon=""
        readonly
        append-outer-icon="$sl-delete"
        class="mt-n4"
        outlined
        :label="$t('labels.label-upload-file')"
        @click:append-outer="deleteFile(file)"
      ></v-text-field>
    </div>

    <v-text-field
      class="mt-n5 font-italic"
      :placeholder="$t('application.documents.loading')"
      v-if="isLoading"
      outlined
      append-outer-icon="$sl-spinner"
    ></v-text-field>

    <v-file-input
      ref="inputGUGCert"
      class="mt-n5 d-none"
      accept=".pdf, .jpg, .tiff, .png"
      :disabled="isLoading"
      v-model="fileInput"
      @change="saveFiles()"
    >
    </v-file-input>

    <ActionButton 
      @click="$refs.inputGUGCert.$refs.input.click()" 
      type="application" 
      actionIcon="$sl-attachment"
    >{{$t('labels.upload-certificate-'+fileType)}}
    </ActionButton>
    <p class="mb-10 mt-4">{{ $t('application.documents-upload') }}</p>
  </v-form>
</template>

<script>
import API from '@/services/api.js'
import {mapActions, mapGetters} from 'vuex'
import ActionButton from '@/components/Common/ActionButton'
import get from 'lodash/get'

export default {
  props: {
    fileType: Number,
    files: Array,
  },

  data: () => ({
    valid: true,
    fileInput: null,
    isLoading: false
  }),

  components: {
    ActionButton,
  },

  computed: {
    ...mapGetters('application', ['selectedApplication']),
  },

  methods: {
    ...mapActions('application', ['updateSelectedApplication']),

    async deleteFile(file) {
      const res = await this.$dialog.confirm({
        title: this.$i18n.t('application.documents.delete-title'),
        text: this.$i18n.t('application.documents.delete-text'),
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true, icon: '$sl-delete', outlined: true}
        ]
      })

      if (res !== true) {
        return
      }

      API.deleteApplicationDocument(file.id)
        .then(response => {
          this.selectedApplication.applicationDocuments.splice(
            this.selectedApplication.applicationDocuments.indexOf(file),
            1
          )
        })
        .catch(error => {
          this.$events.fire('showError', this.$t('application.documents.deleteerror'))
          console.log(error)
        })
    },

    saveFiles() {
      if (!this.fileInput || this.fileInput === null || !this.checkFileSize(this.fileInput.size)) {
        this.fileInput = null
        return
      }

      var formData = new FormData(this.$refs.uploadForm.$el)
      formData.append('file', this.fileInput)
      formData.append('applicationId', get(this,'selectedApplication.id', null))
      formData.append('applicationDocumentTypeId', this.fileType)

      this.isLoading = true

      API.createApplicationDocument(formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(response => {
          if (response && response.data) {
            this.updateStore()
            this.isLoading = false
            this.$events.fire('showInfo', this.$t('application.documents.uploaded'))
            this.fileInput = null
          }
        })
        .catch(error => {
          this.$events.fire('showError', this.$t('application.documents.uploaderror'))
          this.isLoading = false
          console.log('error upload', error)
        })
    },

    updateStore() {
      API.getApplication(this.selectedApplication.id)
        .then(res => {
          if (res && res.data) {
            this.updateSelectedApplication(res.data)
          }
        })
        .catch(err => {console.log('There was an error 1:', err)})
    },

    checkFileSize(size) {
      if (size > 10000000) {
        this.$events.fire('showError', this.$t('errors.save-document-size'))
        return false
      }
      return true
    },

  }
}
</script>

<style>

</style>